import { FormRowSelectAutocomplete } from './FormRowSelectAutocomplete';

export default FormRowSelectAutocomplete;
